var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-up"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.companyid == 12),expression:"companyid == 12"}],staticClass:"server-tip"},[_vm._v(" 平台服务即将到期 ！ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }